module.exports = __webpack_public_path__ + "img/banner.080ac8d6.png";